var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyberArk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4766 6.971L21.1061 6.75954L11.7892 1.38551L2.3707 6.82051V17.6416L2.50087 17.7145L11.7892 23.0521L21.3379 17.5641V11.5357L16.5004 14.3165V9.8287L21.468 6.97498L21.4761 6.971H21.4766ZM12.0787 7.57286L15.9718 9.82472V14.3165L12.0787 12.0686V7.57228V7.57286ZM11.5129 2.16634V6.95445L7.35143 9.36078L3.18484 6.971L11.5123 2.16577L11.5129 2.16634ZM11.5129 7.57286V12.0686L7.62036 14.3165V9.82472L11.5129 7.57286ZM2.91707 7.43436L7.08252 9.82472V14.6254L2.9165 17.0317V7.43436H2.91707ZM3.19796 17.4911L7.35143 15.0888L11.5214 17.4871L11.5294 22.2758L3.19739 17.4911H3.19796ZM11.7938 17.0198H11.7898L7.88467 14.7799L11.7772 12.532L11.7938 12.54L11.8103 12.532L15.7029 14.7799L15.2547 15.0358L11.7978 17.0237H11.7938V17.0198ZM16.7739 14.7799L20.8052 12.4585V17.2472L20.3901 17.4871L12.0587 22.2718L12.0667 17.4831L16.7739 14.7759V14.7799ZM16.2407 9.36136L12.0792 6.95503V2.16577L20.4067 6.97043L16.2413 9.36078L16.2407 9.36136Z",
    fill: "url(#paint0_linear_32636_170644)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7943 23.2148L2.23706 17.7227V6.7353L11.7943 1.21875L21.7626 6.97065L16.6523 9.9099V14.0722L21.4897 11.292V17.6498L11.7943 23.2188V23.2148ZM2.52195 17.5563L2.57904 17.5888L11.7983 22.8853L21.2088 17.4788V11.7799L16.3714 14.5607V9.74349L21.1968 6.97123L11.7983 1.54818L2.52195 6.90172V17.5563ZM11.9199 22.524L11.9279 17.4058L20.9513 12.2148V17.3323L11.9199 22.5194V22.524ZM12.2128 17.5688L12.2048 22.0281L20.6665 17.1664V12.7032L12.2128 17.5649V17.5688ZM11.671 22.524L2.91303 17.4914L7.35138 14.926L11.6636 17.4058L11.6716 22.524H11.671ZM3.48282 17.4914L11.3867 22.0321L11.3787 17.5728L7.35138 15.26L3.48282 17.4959V17.4914ZM2.7743 7.19007L7.22521 9.74689V14.71L2.7743 17.2839V7.19007ZM3.05976 7.68198V16.7875L6.94032 14.5436V9.90933L3.05976 7.68198ZM11.7903 17.1858L7.60029 14.7796L11.7783 12.3692L15.9889 14.7796L11.7989 17.1858H11.7903ZM11.7903 16.8564H11.7943L15.4185 14.779L11.7903 12.6896L8.17009 14.779L11.7903 16.8604V16.8564ZM7.47814 14.5635V9.74234L11.6562 7.32747V12.1526L7.47814 14.563V14.5635ZM7.75901 9.90477V14.0671L11.3667 11.9857V7.82048L7.75901 9.90592V9.90477ZM16.115 14.5635L11.937 12.1532V7.32857L16.115 9.74349V14.5646V14.5635ZM12.2225 11.9862L15.8302 14.0676V9.90535L12.2225 7.8199V11.9862ZM16.2418 9.52689L11.9376 7.03906V1.92206L20.6921 6.97463L16.2412 9.53145V9.52747L16.2418 9.52689ZM12.2225 6.87265L16.2418 9.19805L20.1223 6.97007L12.2213 2.41393V6.87322L12.2225 6.87265ZM7.35253 9.52689L2.90104 6.97065L11.6556 1.91808V7.03565L7.35138 9.52349V9.52747L7.35253 9.52689ZM3.47083 6.97065L7.35138 9.19857L11.3707 6.87322V2.41393L3.47083 6.97065Z",
    fill: "url(#paint1_linear_32636_170644)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32636_170644",
    x1: 12.0084,
    y1: -0.0526164,
    x2: 12.0084,
    y2: 25.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00527273,
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2666,
    stopColor: "#329CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    stopColor: "#296FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296FB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32636_170644",
    x1: 12.0084,
    y1: -0.0526164,
    x2: 12.0084,
    y2: 25.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00527273,
    stopColor: "#38B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2666,
    stopColor: "#329CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    stopColor: "#296FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296FB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberArk);
export default __webpack_public_path__ + "static/media/CyberArk.a6a83ab21ab1953f8280a04ec47c1b4c.svg";
export { ForwardRef as ReactComponent };